// Autogenerated file
export const geocoderSourceTypesEnum = {
    Yandex: "Yandex",
    Nominatim: "Nominatim",
    Dadata: "Dadata",
    Here: "Here",
};
export const geocoderSourceTypes = [
    { label: "Yandex", value: "Yandex" },
    { label: "Nominatim", value: "Nominatim" },
    { label: "Dadata", value: "Dadata" },
    { label: "Here", value: "Here" },
];
